import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Form, Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { FlexibleTextArea } from 'UI/Inputs';
import { Spinner } from 'UI';
import { Button, Icon, Flex, translate } from '@haldor/ui';
import Swal from 'sweetalert2';
var ALLOWED_FILE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.docx', '.doc', '.xlsx', '.xls', '.pdf', '.pptx', '.ppt', '.txt', '.csv'];
var MAX_FILE_SIZE = 52428800; // 50 MB
var MessageForm = /*#__PURE__*/function (_Component) {
  function MessageForm(props) {
    var _this;
    _classCallCheck(this, MessageForm);
    _this = _callSuper(this, MessageForm, [props]);
    _defineProperty(_this, "submit", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var values,
        conversation,
        selectedFile,
        rawText,
        hasText,
        data,
        _args = arguments;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            values = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            conversation = _this.props.conversation;
            selectedFile = _this.state.selectedFile;
            rawText = typeof values.text === 'string' ? values.text : '';
            hasText = rawText.trim() !== '';
            if (!(!hasText && selectedFile == null)) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return");
          case 1:
            _this.setState({
              hideInput: true,
              uploading: true
            });
            data = null;
            if (hasText) {
              data = _objectSpread(_objectSpread({}, values), {}, {
                conversationID: conversation != null ? conversation.id : null,
                parentId: null,
                text: rawText.replace(/\n/g, "<br />"),
                type: 'text'
              });
            }
            _context.prev = 2;
            if (!_this.props.onSubmit) {
              _context.next = 4;
              break;
            }
            _context.next = 3;
            return _this.props.onSubmit(data, selectedFile);
          case 3:
            _this.props.reset();
            _this.setState({
              selectedFile: null
            });
            _context.next = 5;
            break;
          case 4:
            _this.props.reset();
          case 5:
            _context.prev = 5;
            _this.setState({
              hideInput: false,
              uploading: false
            });
            return _context.finish(5);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2,, 5, 6]]);
    })));
    _defineProperty(_this, "required", function (value) {
      if (typeof value !== 'undefined' && value !== '') {
        // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string
        return undefined;
      }

      // Field failed validation, return error for this field (String)
      return "Skriv ett meddelande";
    });
    _defineProperty(_this, "onFileSelect", function (e) {
      var file = e.target.files[0];
      if (!file) return;
      var extension = '.' + file.name.split('.').pop().toLowerCase();
      if (!ALLOWED_FILE_EXTENSIONS.includes(extension)) {
        Swal.fire({
          title: _this.props.translate('Unsupported file type'),
          text: _this.props.translate('Supported file types') + ': ' + ALLOWED_FILE_EXTENSIONS.join(', '),
          icon: 'error',
          confirmButtonText: 'OK'
        });
        e.target.value = null;
        return;
      }
      if (file.size > MAX_FILE_SIZE) {
        Swal.fire({
          title: _this.props.translate('file-too-big'),
          text: _this.props.translate('Size limit for files is') + ' 50 MB',
          icon: 'error',
          confirmButtonText: 'OK'
        });
        e.target.value = null;
        return;
      }
      _this.setState({
        selectedFile: file
      });
      e.target.value = null;
    });
    _defineProperty(_this, "onRemoveFile", function (e) {
      if (e != null) {
        e.preventDefault();
        e.stopPropagation();
      }
      _this.setState({
        selectedFile: null
      });
    });
    _defineProperty(_this, "onAttachClick", function (e) {
      if (e != null) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (_this.fileInput.current) {
        _this.fileInput.current.click();
      }
    });
    _this.fileInput = /*#__PURE__*/React.createRef();
    _this.state = {
      hideInput: false,
      uploading: false,
      selectedFile: null
    };
    return _this;
  }
  _inherits(MessageForm, _Component);
  return _createClass(MessageForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        handleSubmit = _this$props.handleSubmit,
        submitting = _this$props.submitting,
        disabled = _this$props.disabled,
        handleFiles = _this$props.handleFiles,
        textValue = _this$props.textValue;
      var _this$state = this.state,
        selectedFile = _this$state.selectedFile,
        uploading = _this$state.uploading;
      var hasText = typeof textValue === 'string' && textValue.trim() !== '';
      var isSubmitting = submitting || uploading;
      var canSubmit = hasText || selectedFile != null;
      var placeHolderText = this.props.translate('Send message');
      if (this.props.conversation != null && this.props.conversation.status != null) {
        if (this.props.conversation.status.toUpperCase() == "ARCHIVED") {
          placeHolderText = this.props.translate('Conversation is archived');
        }
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "conversation message-form"
      }, /*#__PURE__*/React.createElement(Form, {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "composer-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "composer-shell"
      }, selectedFile != null ? /*#__PURE__*/React.createElement("div", {
        className: "selected-file-badge"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "File"
      }), /*#__PURE__*/React.createElement("span", {
        className: "selected-file-name"
      }, selectedFile.name), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "remove-selected-file",
        onClick: this.onRemoveFile,
        "aria-label": this.props.translate('Remove file')
      }, "\xD7")) : null, !this.state.hideInput ? /*#__PURE__*/React.createElement(Field, {
        component: FlexibleTextArea,
        type: "text",
        name: "text",
        placeholder: placeHolderText,
        rows: 1,
        disabled: disabled,
        ref: this._setInput,
        withRef: true,
        forwardRef: true
      }) : null)), /*#__PURE__*/React.createElement(Button, {
        disabled: isSubmitting || disabled || !canSubmit
      }, !isSubmitting ? /*#__PURE__*/React.createElement(Icon, {
        name: "Send"
      }) : null, isSubmitting ? /*#__PURE__*/React.createElement(Spinner, {
        center: true,
        small: true
      }) : null)), handleFiles ? /*#__PURE__*/React.createElement("div", {
        className: "attach-file-row"
      }, /*#__PURE__*/React.createElement("input", {
        type: "file",
        ref: this.fileInput,
        style: {
          display: 'none'
        },
        accept: ALLOWED_FILE_EXTENSIONS.join(', '),
        onChange: this.onFileSelect
      }), /*#__PURE__*/React.createElement(Button, {
        id: "attach-file-button",
        type: "secondary",
        onClick: this.onAttachClick,
        disabled: disabled || uploading
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "File"
      }), /*#__PURE__*/React.createElement("span", {
        className: "attach-file-label"
      }, this.props.translate('Attach file')))) : null));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  var selector = formValueSelector('MessageForm');
  return {
    translate: translate(state.Languages.translations),
    textValue: selector(state, 'text')
  };
}
export default connect(mapStateToProps)(reduxForm({
  form: 'MessageForm',
  destroyOnUnmount: true
})(MessageForm));